import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { Generate2FaCodeResponse } from './2fa.types'

const generate2FaCode = async (): Promise<Generate2FaCodeResponse> => {
  const response = await apiClient.post<Generate2FaCodeResponse>(
    '/v1/administration/user/2fa/code',
  )
  return response.data
}

export const useGenerate2FaCode = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: () => generate2FaCode(),
    meta: {
      ...feedback,
    },
  })
}
